import { __assign, __decorate, __extends } from "tslib";
import React from 'react';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { TopBar, TopBarDropdown } from '../TopBar';
import { UserAvatar } from '../UserAvatar';
import { MenuItem } from '@skbkontur/react-ui/components/MenuItem';
import { TopBarLocaleHelper } from './locale';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { ThemeFactory } from '@skbkontur/react-ui';
/**
 * Аватар пользователя
 */

var TopBarAvatar =
/** @class */
function (_super) {
  __extends(TopBarAvatar, _super);

  function TopBarAvatar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TopBarAvatar.prototype.render = function () {
    var _this = this;

    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this.theme = getAddonsTheme(theme);
      return React.createElement(ThemeContext.Provider, {
        value: ThemeFactory.create({
          tbItemBorderRadius: '100%',
          tbItemPaddingX: '0',
          tbItemMarginX: '8px'
        }, _this.theme)
      }, _this.renderMain());
    });
  };

  TopBarAvatar.prototype.renderMain = function () {
    var _a = this.props,
        cabinetUrl = _a.cabinetUrl,
        userName = _a.userName,
        children = _a.children,
        onLogout = _a.onLogout;
    return React.createElement(TopBarDropdown, __assign({}, this.props, {
      menuWidth: '240px',
      label: React.createElement(UserAvatar, __assign({}, this.props)),
      positions: ['bottom right']
    }), children || userName && [React.createElement(TopBar.DropdownUserName, {
      userName: userName,
      key: 1
    }), React.createElement(MenuItem, {
      loose: true,
      href: cabinetUrl,
      target: "_blank",
      key: 2
    }, "\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442"), React.createElement(ThemeContext.Provider, {
      key: 3,
      value: ThemeFactory.create({
        tbMenuSeparatorMarginY: '8px',
        menuItemHoverBg: 'rgba(0, 0, 0, 0.05)'
      }, this.theme)
    }, React.createElement(TopBar.DropdownMenuSeparator, null)), React.createElement(MenuItem, {
      loose: true,
      key: 4,
      onClick: onLogout
    }, "\u0412\u044B\u0439\u0442\u0438")]);
  };

  TopBarAvatar.__KONTUR_REACT_UI__ = 'TopBarAvatar';
  TopBarAvatar.defaultProps = {
    cabinetUrl: 'https://cabinet.kontur.ru'
  };
  TopBarAvatar = __decorate([locale('TopBar', TopBarLocaleHelper)], TopBarAvatar);
  return TopBarAvatar;
}(React.Component);

export { TopBarAvatar };